module.exports = __webpack_public_path__ + "static/img/2.7910fb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/eng/2.png
// module id = lUv8
// module chunks = 0